import { render, staticRenderFns } from "./FormCadastro.vue?vue&type=template&id=731d1f62"
import script from "./FormCadastro.vue?vue&type=script&lang=js"
export * from "./FormCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports